import {Injectable} from '@angular/core';
import {ErrorFabricService} from 'app/core/error-handler/error-fabric.service';
import {ErrorNotifierService} from 'app/core/error-handler/error-notifier.service';
import {getCollectionIterator} from 'app/core/helpers/dom';
import {buildInfo} from '../../../environments/buildInfo';
import {HttpClient} from '@angular/common/http';

const NO_IMAGE_SVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
NO_IMAGE_SVG.setAttribute('viewBox', '0 0 64 64');
NO_IMAGE_SVG.innerHTML = `
    <rect x='1' y='1' width='62' height='62' stroke-width='2' stroke='var(--color-1, #000)' fill='transparent'></rect>
    <text fill='var(--color-1, #000)' x='5' y='35'>NO</text>
    <text fill='var(--color-1, #000)' x='5' y='50'>IMAGE</text>
`;

@Injectable()
export class SvgService {
    private images = new Map<string, Element>();

    constructor(
        private http: HttpClient,
        private errorNotifier: ErrorNotifierService,
        private errorFabric: ErrorFabricService
    ) {}

    init() {
        return this.http
            .get('assets/images/svg-lib.html?v=' + buildInfo.version, {
                responseType: 'text',
            })
            .toPromise()
            .then(text => {
                let element = document.createElement('div');
                element.innerHTML = text;
                for (let child of getCollectionIterator(element.children)) {
                    this.images.set(child.getAttribute('id'), child as Element);
                }
            });
    }

    get(id: string): Element {
        if (this.images.has(id)) {
            let copy = this.images.get(id).cloneNode(true) as Element;
            copy.removeAttribute('id');
            copy.setAttribute('data-id', id);
            return copy;
        } else {
            let error = new Error(`Requested image "${id}" does not exist in svg-lib.html`);
            this.errorNotifier.notifyBugTracker(this.errorFabric.createInternalError(error));
            return NO_IMAGE_SVG.cloneNode(true) as Element;
        }
    }
}
